import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { PixelService } from '../../services/pixel.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  currentLanguage = '';
  private readonly translate = inject(TranslateService);
  private readonly pixelService = inject(PixelService);

  links = [
    {
      title: 'top_navigation.nav_about',
      routeName: 'about',
    },
    {
      title: 'top_navigation.nav_howtobuy',
      routeName: 'how-to-buy',
    },
    {
      title: 'top_navigation.nav_roadmap',
      routeName: 'roadmap',
    },
    {
      title: 'top_navigation.nav_faq',
      routeName: 'faq',
    },
  ];

  items = [
    {
      title: 'footer_navigation.terms',
      link: '',
    },
    {
      title: 'footer_navigation.privacy',
      link: '',
    },
    {
      title: 'footer_navigation.cookies',
      link: '',
    },
  ];

  social = [
    {
      img: 'assets/images/svg-icons/social-icons/telegram.svg',
      alt: 'Telegram',
      link: '',
    },
    {
      img: 'assets/images/svg-icons/social-icons/twitter.svg',
      alt: 'Twitter',
      link: '',
    },
  ];

  constructor() {
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });
  }

  trackExternalLink(url: string, name: string): void {
    this.pixelService.trackPageClick(url, name);
  }
}
